export default __webpack_public_path__ + "static/media/bg-bottom.8bac8063.png";